import { AxiosResponse } from "axios";
import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "react-query";
import { SocialsData } from "../../shared/models/FormEntity";
import { APIClient } from "../../utils/api/client";
import { IError } from "../../utils/models";
import { getBaseUrl } from "../endpoints";

import { queryToString } from "../../utils/functions";

export interface IGetSocialsConfig {
}


const SocialServices = {
  getAll: (data?: any): Promise<SocialsData[]> => {
    return APIClient.get(getBaseUrl({path:`company/social${queryToString(data)}`}));
  },
  getSingle: (data: string | string[] | undefined): Promise<SocialsData[]> => {
    return APIClient.get(getBaseUrl({path:`company/social/${data}`}));
  },
  create: (data?: any): Promise<AxiosResponse<SocialsData>> => {
    return APIClient.post( getBaseUrl({path:'company/social'}), data);
  },
  update: (data?: any): Promise<AxiosResponse<SocialsData[]>> => {
    return APIClient.put( getBaseUrl({path:'company/social'}), data);
  },
  delete: (data?: any): Promise<AxiosResponse<{}>> => {
    return APIClient.delete(getBaseUrl({path:'company/social'}),{ data:data });
  },
};

export const useSocialQuery = {
  useGetAll: (
    data?: any,
    meta?: IGetSocialsConfig
  ): UseQueryResult<SocialsData[], IError> => {
    return useQuery<SocialsData[], IError>(
      ["get-socials", data],
      async (): Promise<SocialsData[]> => {
        const res = await SocialServices.getAll(data);
        return res;
      }
    );
  },
  useGetSingle: (
      identifier: string | string[] | undefined,
      meta?: IGetSocialsConfig
    ): UseQueryResult<SocialsData[]> => {
      return useQuery<SocialsData[]>(
        ["get-social", identifier],
        async (): Promise<SocialsData[]> => {
          const res = await SocialServices.getSingle(identifier);
          return res;
        },
        {
          cacheTime:0
        }
      );
    },
  useCreate: (onSuccess:() => void): UseMutationResult<SocialsData, IError> => {
    return useMutation<SocialsData, IError, unknown>(
      async (data:any): Promise<SocialsData> => {
        const res = await SocialServices.create(data);
        return res?.data;
      },
      {
        onSuccess:onSuccess
      }
    );
  },
  useUpdate: (onSuccess:() => void): UseMutationResult<SocialsData[], IError> => {
    return useMutation<SocialsData[], IError, unknown>(
      async (data:any): Promise<SocialsData[]> => {
        const res = await SocialServices.update(data);
        return res?.data;
      },
      {
        onSuccess:onSuccess
      }
    );
  }, 
  useDelete: (onSuccess:(data:any) => void): UseMutationResult<{}, IError> => {
    return useMutation<{}, IError, unknown>(
      async (data:any): Promise<{}> => {
        const res = await SocialServices.delete(data);
        return res;
      },
      {
        onSuccess:onSuccess
      },
      
    );
  },
};

export default useSocialQuery;
